import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
import { Row, Col, Button, Card, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const PaymentSuccess = () => {

    const navigate = useNavigate()


  const location = useLocation();
  const { paymentId, name } = location.state || {};

  return (

    <div className="student-page">
                <Header />
                <header className="height-75">
                    <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
                        <h1 className="text-center fw-semibold">Payment Success</h1>
                    </div>
                </header>
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
  <div className="card shadow-lg p-4" style={{ width: '100%', maxWidth: '450px' }}>
    <div className="card-body text-center">
      <h2 className="mb-3">🎉 Payment Successful!</h2>
      <p className="mb-2">Your Payment ID:</p>
      <h5 className="text-success"><strong>{paymentId}</strong></h5>
      <p className="mt-3">Thank you for your payment.</p>
      <Button variant="primary" onClick={() => navigate("/")}>
        Go to Home
      </Button>
    </div>
  </div>
</div>


<Footer/>
    </div>
  );
};

export default PaymentSuccess;
